import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';
import { Logo } from '@anyroad/logo';
import { Spinner } from '@anyroad/spinner';

type LoadingPageProps = {
  dataTestId?: string;
  /** The data-testid attribute. */
  message?: string | null;
};

const Container = styled.div({
  alignItems: 'center',
  background: colors.background.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100%',
});

const StyledLogo = styled(Logo)({
  marginBottom: '6rem',
});

const Message = styled.div({
  marginTop: '2rem',
  color: colors.grays['50'],
  textAlign: 'center',
  fontWeight: 600,
  fontSize: '1.5rem',
});

/**
 * LoadingPage component.
 *
 * @type {React.FC<LoadingPageProps>}
 * @returns {React.ReactElement} The loading-page.
 * @example
 * import { LoadingPage } from './LoadingPage';
 */
export const LoadingPage = forwardRef<HTMLDivElement, LoadingPageProps>(
  ({ dataTestId, message }, ref) => (
    <Container data-testid={dataTestId} ref={ref}>
      <StyledLogo type="lightbg" />
      <Spinner />
      <Message>{message}</Message>
    </Container>
  )
);

LoadingPage.displayName = 'LoadingPage';
